import { v2Api } from './v2Client';

export async function fetchAppSettings() {
  const { data } = await v2Api.get('/AppSettings');
  return data;
}

export async function updateAppSettings(body) {
  const { data } = await v2Api.put('/AppSettings', body);
  return data;
}

export async function fetchSeasonMirrorDraft() {
  const { data } = await v2Api.get('/AppSettings/season_mirror_draft');
  return data?.season_mirror_draft ?? null;
}

export async function saveSeasonMirrorDraft(json) {
  const { data } = await v2Api.put('/AppSettings/season_mirror_draft', { season_mirror_draft: json ?? null });
  return data?.season_mirror_draft ?? null;
}
